import { useContext, useState } from 'react';

import { LeadCreation, NotificationType } from 'shared/topchef.types'
import api from "shared/topchef-api-places";
import { useNavigate, useOutletContext } from 'react-router';
import { PlaceOutletContextType } from '../home/PlacesHome';
import { NotificationContext } from 'shared/NotificationContext'
import { useErrorBoundary } from 'react-error-boundary'
import LeadEditor from 'pages/shared/lead-editor/LeadEditor';
import ShareLeadWithAi from '../share-lead-with-ai/ShareLeadWithAi';

const ShareLead = () => {

  const navigate = useNavigate();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();
  
  const [leadToCreate, setLeadToCreate] = useState<LeadCreation>({
    type: '',
    targetDate: '',
    startTime: '',
    endTime: '',
    guests: '',
    budget: '',
    region: '',
    city: '',
    description: '',
    contactName: '',
    contactCompany: '',
    contactEmailAddress: '',
    contactMobilePhone: '',
    contactLandlinePhone: ''
  });



  const changeInitialData = async (leadCreation: LeadCreation) => {
    const leadCreationWithoutNulls = convertNullFieldsToEmptyStrings(leadCreation);
    setLeadToCreate(() => {
      return { ...leadCreationWithoutNulls }; 
    });
  };


  // to prevent react warnings : A component is changing a controlled input to be uncontrolled. This is likely caused by...
  const convertNullFieldsToEmptyStrings = (input: LeadCreation) :LeadCreation => {
    return JSON.parse(JSON.stringify(input), (_key, value) => {
      if (value === null || value === "null") {
        return '';
      }
      return value;
    });
  }


  const updateLeadCreationState= (name: string, value: string) => {
    setLeadToCreate((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const createPublicLead = async (leadCreation: LeadCreation) => {
    try {
      await api.shareLead(loggedInPlace!.id, leadCreation);
      triggerNotification({type: NotificationType.information, message : "Brief envoyé ! Il doit être validé par l’équipe Loc’Hall avant mise en ligne dans le briefs market"}); 
      navigate('/places/shared-leads');
    } catch (error: any) {
      const newError = new Error(`Erreur lors du partage du brief : ${error.message}`);
      triggerNotification({type: NotificationType.error, message : `${newError.message}`});
      return showBoundary(newError);
    }
  };


  return (
    
    <div className="page-add-brief container p-5 overflow-y-auto row m-0">
  
        <ShareLeadWithAi initLeadCreationInfo={changeInitialData} />

        <div className="col-md-7 p-0 mb-5">
            <LeadEditor formData={leadToCreate} onDataChange={updateLeadCreationState} onSubmit={createPublicLead} submitButtonLabel="Valider le brief" />
        </div>

    </div>
  );

}

export default ShareLead;
